import { DataEntity } from './element.model';

export class ContextMenuConfiguration {
  definitions: ContextMenuObjectTypeDefinition[];

  constructor() {
    this.definitions = new Array<ContextMenuObjectTypeDefinition>();
  }
}

export class ContextMenuObjectTypeDefinition {
  objectTypes: string[];
  buttons: ContextMenuButton[];

  constructor() {
    this.buttons = new Array<ContextMenuButton>();
    this.objectTypes = new Array<string>();
  }
}

export class ContextMenuButton {
  name: string;
  action: (entity: DataEntity) => Promise<void>;
  svgImage: string;
  tooltip: string;
  visible: boolean;
  enabled: boolean;
  enabledCondition: (entity: DataEntity) => Promise<boolean>;
  enabledByBadgeValue: boolean;
  badgeValueExpression: (entity: DataEntity) => Promise<number>;
  badgeHidden: boolean;
  badgeValue: number;

  constructor() {}
}

export enum RadialMenuOrientation {
  radial,
  right,
  left,
  top,
  bottom,
}
